<template>
  <div>
    <game-title-layout :show-top="showTop"></game-title-layout>
    <slotsDetailLayout
      :mapList ="mapList"
      :mapListDetail ="mapListDetail"
      :mapIndex="mapIndex"
      :lang="lang"
      :Phone = "Phone"
      :linesId="0"
      :remainFreeCount="remainFreeCount"
      :sumRows="sumRows"
      :sumColumns="sumColumns"
      :checkFreeColor="checkFreeColor"
      :freeId = "freeId"
      :imgAreaClassId="imgAreaClassId"
      :imgImgDetailClassId="imgImgDetailClassId"
      :mapTopClass="mapTopClass"
      :mapBottomClass="mapBottomClass"
      :checkScatterWin ="checkScatterWin"
      :scatterWin ="scatterWin"
      :scatterItem ="scatterItem"
      :isCheckTable="isCheckTable"
      :checkTable="checkTable"
      :gamePath="gamePath" />
     <div>
      <slotsMapsDetailLayout
        :mapList ="subMapList"
        :mapListDetail ="subMapListDetail"
        :mapIndex="subMapIndex"
        :lang="lang"
        :Phone = "Phone"
        linesId="s"
        :remainFreeCount="remainFreeCount"
        :sumRows="sumRows"
        :sumColumns="sumColumns"
        :checkFreeColor="checkFreeColor"
        :freeId = "freeId"
        :imgAreaClassId="imgAreaClassId"
        :mapTopClass="mapTopClass"
        :mapBottomClass="mapBottomClass"
        :imgImgDetailClassId="imgImgDetailClassId"
        :isCheckTable="isCheckTable"
        :checkTable="checkTable"
        :gamePath="gamePath" />
     </div>
    <SlotsWinTotalLayout
      :show-total="showTotal"
      :win-value-total="winValueTotal">
    </SlotsWinTotalLayout>
  </div>
</template>
<script>
  import slots_detail_layout from "./slots_detail_layout.vue";
  import slots_maps_detail_layout from "./slots_maps_detail_layout.vue";
  import SlotsWinTotalLayout from "./slots_win_total_layout.vue";
  import GameTitleLayout from "../../common/game_detail_title.vue";

  export default
  {
    name: "SlotsMapTwoLayout",
    components: {
      GameTitleLayout,
      SlotsWinTotalLayout,
      'slotsDetailLayout': slots_detail_layout,
      'slotsMapsDetailLayout': slots_maps_detail_layout,
    },
    props: {
      showTop:false,
      gamePath:"",
      lang: '',
      Phone:false,
      mapIndex: [],
      mapList: [],
      mapListDetail: [],
      subMapIndex: [],
      subMapList: [],
      subMapListDetail: [],
      isFree: false,
      showTotal:false,
      winValueTotal:"",
      checkFreeColor: false,
      freeId:'S',
      remainFreeCount:3,
      sumRows:3,
      sumColumns:5,
      imgAreaClassId:"",
      imgImgDetailClassId:"",
      checkScatterWin: false,
      scatterWin:false,
      scatterItem:"S",
      mapTopClass:[],
      mapBottomClass:[],
      isCheckTable: false,
      checkTable:  [],
    },
    data() {
      return {

      };
    },
    created() {
      console.log("checkFreeColor::"+this.checkFreeColor)
    },
    methods: {
      getShowTotal(){
        if(this.showTotal){
          return Boolean(this.showTotal);
        }
        return false;
      },
    }
}
</script>
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/slots/layout/slots_map_two_layout.vue